export default {
  title: 'ギフトを選択',
};
